export default {
	PickColor: 'Pick Color',
	Close: 'Close',
};
